import React, { FC } from 'react';
import { DataTableFilter, DataTableFilters } from '@utmost.co/utmost-design-system';
import { ChipsSelect } from '@beeline.com/bp-design-system';
import { CustomFieldDefinitionEntityTypeModel } from 'src/graphql/types';
import { filterNotEmpty } from 'src/utils/data/listHelpers';
import { useCustomFieldsAndObjectsIntl } from '../translations/useCustomFieldsAndObjectsIntl';
import { CustomFieldDefinitionQuery } from './utils/CustomFields.types';
import { entityTypesOptions } from './utils/CustomFieldsDefinitions.constants';

interface Props {
  query: CustomFieldDefinitionQuery['query'];
}

export const CustomFieldDefinitionsFilters: FC<React.PropsWithChildren<Props>> = ({ query }) => {
  const intl = useCustomFieldsAndObjectsIntl();
  return (
    <DataTableFilters>
      {({ onQueryChange }) =>
        filterNotEmpty([
          <DataTableFilter
            id="parentEntityType"
            key="parentEntityType"
            value={query?.parentEntityType}
            label={intl.entityType}
          >
            <ChipsSelect<CustomFieldDefinitionEntityTypeModel>
              onSelect={(parentEntityType) => onQueryChange({ parentEntityType })}
              value={query?.parentEntityType ?? undefined}
              label={intl.entityType}
              options={entityTypesOptions}
            />
          </DataTableFilter>
        ])
      }
    </DataTableFilters>
  );
};
